enum BiteLogFatalError {
  None = 0,

  ReachabilityDown = 21,

  ScannerDisconnected = 22,
  ScaleDisconnected = 24,
  ScannerMissing = 25,
  ScaleMissing = 26,

  KitchenPrinterMissing = 32,
  KitchenPrinterDisconnected = 4,
  KitchenPrinterNoPaper = 5,
  KitchenPrinterCoverOpen = 6,
  KitchenPrinterConsecutiveFailedJobs = 10,

  ReceiptPrinterMissing = 31,
  ReceiptPrinterDisconnected = 12,
  ReceiptPrinterConsecutiveFailedJobs = 13,
  ReceiptPrinterNoPaper = 14,
  ReceiptPrinterCoverOpen = 15,

  PaymentTerminalUpdating = 19,
  PaymentTerminalDisconnected = 20,
  PaymentTerminalMissing = 27,

  PeripheralKdsDisconnected = 80,
  PeripheralLrsTableTrackerDisconnected = 81,
  PeripheralMsrDisconnected = 82,
  PeripheralTouchDisplayDisconnected = 83,

  MenuDataMissing = 50,
  UsersDataMissing = 51,
  ScriptMissing = 61,
  ImageMissing = 62,
  WebViewNotReady = 63,

  KioskError = 70,

  Unstarted = 100,
}

export { BiteLogFatalError };
